import * as yup from 'yup';

export const validationSchema = yup.object({
    label: yup
        .string()
        .required("Required"),
    type: yup
        .string()
        .required("Required"),
    vehiclePlateNo: yup
        .string()
        .required("Required"),
    description: yup
        .string()
        .required("Required"),
    // remark: yup
    //     .string()
    //     .required("Required"),
    vehicleModel: yup
        .string()
        .required("Required"),
    vehicleBrand: yup
        .string()
        .required("Required"),
})

export const initialValues = {
    
    label: "",
    type: "",
    vehiclePlateNo: "",
    vehicleModel: "",
    vehicleBrand: "",
    description:"",
    remark: "",
    status: true,
}